import React from "react";
import { Routes, BrowserRouter, Route } from "react-router-dom";

import * as Material from "@mui/material";

import { Confirm } from "@fragments";
import UserModal from "@components/Modals/UserModal";
import ShareContentModal from "@components/Modals/ShareContentModal/index.js";

import { AuthProvider } from "@contexts/AuthContext.js";
import { CommunityProvider } from "contexts/community";

import { ThemeProvider } from "@mui/material/styles";

import theme from "./assets/theme.js";

import H from "@helpers/H.js";

import { ScreenProvider, useScreen as useLegacyScreen } from "@hooks/useScreen";

import routes from "./routes";

import "./App.css";
import "./assets/spacing.css";
import Screen from "Screen/index.js";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <AuthProvider>
          <CommunityProvider>
            <ScreenProvider>
              <ProtectedRoutes />
            </ScreenProvider>
          </CommunityProvider>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

function ScreenLayers({ children }) {
  return (
    <Screen>
      {children}
    </Screen>
  )
}

function SnackbarHost() {
  const { snackbar, setSnackbar } = useLegacyScreen();
  if (!snackbar) return null;
  return (
    <Material.Portal>
      <Material.Snackbar
        className="custom-snackbar"
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={!!snackbar}
        onClose={() => setSnackbar(null)}
        message={snackbar}
        TransitionComponent={Material.Fade}
        TransitionProps={{ timeout: { enter: 0, exit: 200 } }}
        sx={{ zIndex: 9999 }}
      />
    </Material.Portal>
  );
}

const ProtectedRoutes = () => {
  window.helpers = H;

  return (
    <>
      <SnackbarHost />
      <ScreenLayers>
        <Routes>
          {Object.keys(routes).map((path, i) => {
            const Component = routes[path];
            return (
              <Route
                path={"/" + path}
                key={i}
                element={
                  <>
                    <Confirm />
                    <UserModal />
                    <Component />
                    <ShareContentModal />
                  </>
                }
              />
            );
          })}
        </Routes>
      </ScreenLayers>
    </>
  );
};

export default App;
